import { Loader2 } from 'lucide-react';

/**
 * Full-viewport loading state shown while the session bootstraps or a lazy
 * route chunk resolves. Deliberately minimal and theme-aware.
 */
export function RouteSplashScreen() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-screen w-full items-center justify-center bg-background"
    >
      <Loader2 className="size-8 animate-spin text-primary" aria-hidden="true" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
